import queryString from 'query-string';
import { ChromeEvent } from '@amzn/aac-chrome-api';

export const limitTextLength = (text, maxLength) => {
  return text.length > maxLength ? `${text.substr(0, maxLength - 3)}...` : text;
};

// The currentLocation parameter should be a Location Object (https://developer.mozilla.org/en-US/docs/Web/API/Location)
export const getUrlWithoutParameter = (currentLocation, param) => {
  const urlParams = queryString.parse(window.location.search);
  delete urlParams[param];

  // Object.keys is not supported in IE < 9
  const newUrlParams =
    Object.keys(urlParams).length === 0
      ? ''
      : `?${queryString.stringify(urlParams)}`;

  return `${currentLocation.pathname}${newUrlParams}${currentLocation.hash}`;
};

function getEventHandler(elementConfig, eventId, eventTarget, eventType) {
  return (event) => {
    const chromeEvent = new ChromeEvent(eventId);
    chromeEvent.originEvent = event;
    chromeEvent.targetItemConfig = elementConfig;
    if (typeof elementConfig[`on${eventType}Callback`] !== 'undefined') {
      elementConfig[`on${eventType}Callback`](chromeEvent);
    } else if (typeof eventTarget !== 'undefined') {
      eventTarget.dispatchEvent(chromeEvent);
    }
  };
}

export const getClickEventHandler = (elementConfig, eventTarget?) => {
  return getEventHandler(elementConfig, elementConfig.id, eventTarget, 'Click');
};

export const getCloseEventHandler = (elementConfig, eventTarget) => {
  return getEventHandler(
    elementConfig,
    elementConfig.aacEventId,
    eventTarget,
    'Close',
  );
};

// This method checks if the script[type=internal-chrome-context] exists on the page. It is currently printed on the page by BigTopSharedWidgetService.
export const isBtswContext = (): boolean => {
  const initContextTag = document.querySelector(
    'script[type=internal-chrome-context]',
  );
  return initContextTag !== null;
};

export const isFromBtswWc = (): boolean => {
  return !!document.querySelector(
    'meta[name="a2z:btsw_initial_chrome_config"]',
  );
};

export const isFromTrim = (): boolean => {
  return !!document.querySelector('meta[name="a2z:mons_site_name"]');
};

export const shouldLoadSystemJsAssets = (): boolean => {
  return window.System && window.System.import && !isFromTrim();
};

export const getMonsWeblabTreatment = (weblabName: string): string | null => {
  const meta = document.querySelector('meta[name="a2z:mons_weblab_treatment"]');
  if (!meta) {
    return null;
  }
  const content = meta.getAttribute('content') || '';
  const entries = content.split(',');
  for (const entry of entries) {
    const [name, treatment] = entry.trim().split('=');
    if (name === weblabName) {
      return treatment || null;
    }
  }
  return null;
};
